var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-4 mx-auto"},[_c('b',[_vm._v("Kép párosítás száma:")]),_vm._v(" "+_vm._s(_vm.task.taskable.image_gallery.length)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Eltalált párosítás:")]),_vm._v(" "+_vm._s(_vm.successPairing)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }